import { selectorFamily } from "recoil";

import {
  DEFAULT_WEEKEND_DURATION_DAYS,
  DEFAULT_WEEKEND_START_DAY,
} from "../../constants";
import { TopCalendarMode } from "../../enums";
import { getCalendarModeForDateUnit } from "../../helpers";
import { RydeUiUnit } from "../../models";
import {
  systemSettingsDtoAtom,
  topCalendarDatesAtomFamily,
  topCalendarModeAtomFamily,
} from "../atoms";
import { timezoneSelector } from "./system-settings.selectors";

export const topCalendarModeSF = selectorFamily<TopCalendarMode, RydeUiUnit>({
  key: "topCalendarModeSF",
  get:
    entity =>
    ({ get }) => {
      const mode = get(topCalendarModeAtomFamily(entity));

      if (mode) {
        return topCalendarModeAtomFamily(entity);
      }

      const dates = get(topCalendarDatesAtomFamily(entity));

      if (!dates) {
        return TopCalendarMode.CUSTOM;
      }

      const systemParams = get(systemSettingsDtoAtom);
      const timezone = get(timezoneSelector);
      const weekendStart =
        systemParams?.metadata.weekendStart ?? DEFAULT_WEEKEND_START_DAY;
      const weekendDuration =
        systemParams?.metadata.weekendDuration ?? DEFAULT_WEEKEND_DURATION_DAYS;

      return getCalendarModeForDateUnit({
        dates,
        weekendStart,
        weekendDuration,
        timezone,
      });
    },
});
